// retina対応
const initRetina = () => {
  console.log("retina set");
  if (window.devicePixelRatio < 2) return;

  const retinaPattern = /\.(?=(?:png|jpg|jpeg).*$)/i;
  document.querySelectorAll('.retina').forEach((img) => {
    const src = img.getAttribute('src') || img.dataset.src;
    if (!src) return;
    img.setAttribute('srcset', `${src.replace(retinaPattern, '--2x.')} 2x`);
  });
};

/* アコーディオン開閉
 * 前提 : 1.開く要素はクリック要素の次の要素（nextElementSibling）
 *        2.css でmax-heightが0に設定されている。
-------------------------------------------------- */
const accordion = () => {

  const moreBtn = Array.from(document.querySelectorAll('.js-accordion-btn'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function() {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;
      
      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });
}

// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const href = trigger.getAttribute('href');
      const target = document.querySelector(href === '#' || href === '' ? 'html' : href);
      if (!target) return;

      const position = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: position, behavior: 'smooth' });
    });
  });
};

// 固定ナビの現在地変更
const initNavCurrent = () => {
  setNavCurrent();
};

const setNavCurrent = () => {
  const nav = document.querySelector('.fixed-content__nav');
  if (!nav) return;

  const navItems = Array.from(nav.querySelectorAll('.fixed-content__item')).map((item) => {
    const link = item.querySelector('a[href^="#"]');
    const href = link ? link.getAttribute('href') : '';
    const section = href && href !== '#' ? document.querySelector(href) : null;
    return { item, section };
  }).filter((entry) => entry.section);

  if (!navItems.length) return;

  const scroll = window.pageYOffset || document.documentElement.scrollTop;
  const offset = 100;
  const scrollBottom = scroll + window.innerHeight;
  const pageBottom = document.documentElement.scrollHeight;

  let current = navItems[0];

  if (scrollBottom >= pageBottom - 10) {
    current = navItems[navItems.length - 1];
  } else {
    navItems.forEach((entry) => {
      const top = entry.section.getBoundingClientRect().top + scroll;
      if (scroll + offset >= top) {
        current = entry;
      }
    });
  }

  navItems.forEach(({ item }) => item.classList.remove('fixed-content__item--current'));
  current.item.classList.add('fixed-content__item--current');
};

// 固定ヘッダーの色切り替え
const initHeaderColor = () => {
  setHeaderColor();
};

const setHeaderColor = () => {
  const header = document.querySelector('.fixed-header');
  if (!header) return;

  const headerBottom = header.getBoundingClientRect().bottom;
  const darkZones = document.querySelectorAll('[data-header-color="dark"]');
  let isDark = false;

  const getIntersectRect = (a, b) => {
    const left = Math.max(a.left, b.left);
    const right = Math.min(a.right, b.right);
    const top = Math.max(a.top, b.top);
    const bottom = Math.min(a.bottom, b.bottom);
    if (left >= right || top >= bottom) return null;
    return { left, right, top, bottom };
  };

  darkZones.forEach((zone) => {
    let rect = zone.getBoundingClientRect();
    const sticky = zone.closest('.appeal__sticky');
    if (sticky) {
      const clipped = getIntersectRect(rect, sticky.getBoundingClientRect());
      if (!clipped) return;
      rect = clipped;
    }

    const isSection = zone.tagName === 'SECTION';
    const isOverlapping = isSection
      ? rect.top <= 0 && rect.bottom > 0
      : rect.top < headerBottom && rect.bottom > 0;

    if (isOverlapping) {
      isDark = true;
    }
  });

  header.classList.toggle('is-dark', isDark);
};

// appeal要素 横スクロール（sticky固定 + スクロール連動）
// スクロール量（10 = 縦10pxで横1px移動）
const APPEAL_SCROLL_RATIO = 2;
// 最後要素から次の要素まで行くまでの余白
const APPEAL_END_PADDING = 500;

const setupAppealLayout = () => {
  const appeal = document.querySelector('.appeal');
  const sticky = document.querySelector('.appeal__sticky');
  const track = document.querySelector('.appeal__track');
  if (!appeal || !sticky || !track) return null;

  const items = track.querySelectorAll('.appeal__item');
  const panelWidth = sticky.offsetWidth;
  if (!panelWidth || !items.length) return null;

  items.forEach((item) => {
    item.style.flex = `0 0 ${panelWidth}px`;
    item.style.width = `${panelWidth}px`;
    item.style.marginLeft = '0';
  });

  track.style.width = `${panelWidth * items.length}px`;

  const panelHeight = sticky.offsetHeight;
  const scrollDistance = panelWidth * (items.length - 1);
  const scrollLength = scrollDistance * APPEAL_SCROLL_RATIO;
  appeal.style.height = `${panelHeight + scrollLength + APPEAL_END_PADDING}px`;

  return { appeal, sticky, track, scrollDistance, panelHeight, scrollLength };
};

const updateAppealScroll = () => {
  const appeal = document.querySelector('.appeal');
  const sticky = document.querySelector('.appeal__sticky');
  const track = document.querySelector('.appeal__track');
  if (!appeal || !sticky || !track) return;

  const totalScrollLength = appeal.offsetHeight - sticky.offsetHeight;
  const horizontalScrollLength = totalScrollLength - APPEAL_END_PADDING;
  if (horizontalScrollLength <= 0) return;

  const items = track.querySelectorAll('.appeal__item');
  const scrollDistance = sticky.offsetWidth * (items.length - 1);
  if (scrollDistance <= 0) return;

  const progress = Math.min(1, Math.max(0, -appeal.getBoundingClientRect().top / horizontalScrollLength));

  track.style.transform = `translate3d(${-scrollDistance * progress}px, 0, 0)`;
};

// スライダー
const initSlider = () => {
  if (!document.querySelector('.mv-slider')) return;

  new Swiper('.mv-slider', {
    slidesPerView: 1.3,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    speed: 8000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
  });

  new Swiper('.reason-slider1', {
    slidesPerView: 1.15,
    spaceBetween: 18,
    //autoplay: { delay: 4000 },
    roundLengths: true,
    centeredSlides: false,
    loop: false,
    pagination: {
      el: '.about__reason-pagenation--1',
      clickable: true,
    },
  });

  new Swiper('.reason-slider2', {
    slidesPerView: 1.15,
    spaceBetween: 18,
    //autoplay: { delay: 4000 },
    roundLengths: true,
    centeredSlides: false,
    loop: false,
    pagination: {
      el: '.about__reason-pagenation--2',
      clickable: true,
    },
  });

  new Swiper('.detail-slider', {
    slidesPerView: 1,
    spaceBetween: 18,
    //autoplay: { delay: 4000 },
    roundLengths: true,
    centeredSlides: false,
    loop: true,
    pagination: {
      el: '.detail-pagenation',
      clickable: true,
    },
  });

  const shoppingSliderThumbnail = new Swiper('.shopping-slider-thumbnail', {
    slidesPerView: 'auto',
    spaceBetween: 8,
    freeMode: true,
    watchSlidesProgress: true,
  });

  new Swiper('.shopping-slider', {
    slidesPerView: 1,
    roundLengths: true,
    centeredSlides: false,
    loop: true,
    speed: 300,
    thumbs: {
      swiper: shoppingSliderThumbnail,
    },
  });

};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach((elem) => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > 751 ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// scrollでis-onクラスを付与する
const setIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach((elem) => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 固定CTAの表示区間（A・Bのidを変更するだけで調整可能）
const FIXED_CTA_RANGE = {
  startId: 'intro',       // A: 表示開始位置
  endId: 'shopping-btn',   // B: 非表示位置
};

// 固定CTAの表示制御
const dispCta = () => {
  const fixedCta = document.getElementById('fixed-cta');
  const startElem = document.getElementById(FIXED_CTA_RANGE.startId);
  const endElem = document.getElementById(FIXED_CTA_RANGE.endId);
  if (!fixedCta || !startElem || !endElem) return;

  const hasPassedStart = startElem.getBoundingClientRect().top < window.innerHeight / 2;
  const hasReachedEnd = endElem.getBoundingClientRect().top < window.innerHeight;

  if (hasPassedStart && !hasReachedEnd) {
    fixedCta.classList.add('show');
  } else {
    fixedCta.classList.remove('show');
  }
};


/* モーダル開閉
-------------------------------------------------- */
const closeModal = (modal) => {
  if (!modal) return;
  document.body.style.overflow = '';
  modal.classList.remove('active');
};

const initModal = () => {
  document.querySelectorAll('.modalContent').forEach((modal) => {
    modal.querySelectorAll('.modalContent__close, .overlay, .js-modal-close').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal(modal);
      });
    });
  });
};

function setModal(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return false;
  document.body.style.overflow = 'hidden';
  modal.classList.add('active');
  return true;
}


(() => {

  const init = () => {
    const body = document.querySelector('body');
    body.style.opacity = '1';
    body.classList.remove('preload');

    initRetina();
    accordion();
    initSlider();
    initSmoothScroll();
    initNavCurrent();
    initHeaderColor();
    initModal();
    setupAppealLayout();
    updateAppealScroll();
    doFade();
    setIsOn();
    dispCta();
  };

  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      setIsOn();
      setNavCurrent();
      setHeaderColor();
      dispCta();
      lastScrollTime = now;
    }
  };

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', () => {
    requestAnimationFrame(() => {
      setupAppealLayout();
      updateAppealScroll();
      doFade();
      setIsOn();
      setNavCurrent();
      setHeaderColor();
      dispCta();
    });
  });
  window.addEventListener('resize', () => {
    setupAppealLayout();
    updateAppealScroll();
  });
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('scroll', updateAppealScroll, { passive: true });

})();
